import React from "react";

const Devcard = () => {
  const devData = [
    {
      id: 1,
      title: "Web & mobile applications",
      desc: "We build top-of-the-line responsive web-based software and mobile apps for Android and iOS, ensuring a seamless user experience across devices.",
    },
    {
      id: 2,
      title: "Enterprise-level software",
      desc: "We design robust software solutions that cater to the unique challenges and demands, prioritizing scalability, security, and efficiency.",
    },
    {
      id: 3,
      title: "MVP development",
      desc: "Streamlined version of your software idea to test the waters, gather feedback, and pave the way for full-scale development.",
    },
    {
      id: 4,
      title: "Website development",
      desc: "We design and develop engaging websites that resonate with your brand, drive traffic, and convert visitors into loyal customers.",
    },
  ];
  return (
    <div>
      <div className="dev-card-container">
        {devData.map((data) => (
          <div className="dev-card" key={data.id}>
            <span>{data.icon && data.icon}</span>
            <h1>{data.title}</h1>
            <p>{data.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Devcard;
